var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#52575C",
    fillRule: "evenodd",
    d: "M17 2c0-.552-.448-1-1-1s-1 .448-1 1v1H9V2c0-.552-.448-1-1-1s-1 .448-1 1v1H5C3.343 3 2 4.343 2 6v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3V6c0-1.657-1.343-3-3-3h-2V2zm3 7V6c0-.552-.448-1-1-1h-2v1c0 .552-.448 1-1 1s-1-.448-1-1V5H9v1c0 .552-.448 1-1 1s-1-.448-1-1V5H5c-.552 0-1 .448-1 1v3h16zM4 11h16v9c0 .552-.448 1-1 1H5c-.552 0-1-.448-1-1v-9z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSvg);
export default __webpack_public_path__ + "static/media/calendarSvg.2880d40ce6ed1f7252474d83c36dee8e.svg";
export { ForwardRef as ReactComponent };